(function(angular) {
    /**
     * @ngdoc service
     * @name ConfirmationModalService
     * @description Service used to trigger a confirmation modal
     */
    class ConfirmationModalService {
        static get $inject() {
            return ['$injector'];
        }

        constructor($injector) {
            this.wtModal = $injector.get('wtModal');
            this.$translate = $injector.get('$translate');
        }

        /**
         * @ngdoc method
         * @name ConfirmationModalService#confirm
         * @description Triggers a confirmation modal with the provided message. The returned promise resolves a boolean based on the users input.
         * @param {string} message The confirmation message
         * @param {Object} translateParams The translation params if the message has placeholders
         * @returns {Promise}
         */
        confirm(message, translateParams = {}) {
            return this.wtModal.show({
                controller: 'ConfirmationModalController',
                controllerAs: '$ctrl',
                template: 'src/confirmation-modal/confirmation-modal.modal.html',
                size: 'sm',
                resolve: {
                    message: () => this.$translate.instant(message, translateParams)
                }
            }).result;
        }
    }

    angular.module('wtUi')
        .service('confirmationModalService', ConfirmationModalService);
})(window.angular);
